export const LIBRARY_NAME = '@wallaby-ui/merie';
export const APPLICATION_NAME_MERIE = 'MERIE';

export default {LIBRARY_NAME};
